import { render, staticRenderFns } from "./WelcomePage.vue?vue&type=template&id=00353bde&scoped=true&"
import script from "./WelcomePage.vue?vue&type=script&lang=ts&"
export * from "./WelcomePage.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomePage.vue?vue&type=style&index=0&id=00353bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00353bde",
  null
  
)

export default component.exports